<script>
  import { onMount } from "svelte";
  import { goto } from "@/utils/navigationUtils";
  import FeedWrapper from "@/components/organisms/FeedWrapper.svelte";
  import profileStore from "@/stores/profile";
  import FeedWrapperHead from "@/components/molecules/FeedWrapperHead.svelte";
  import userProfileStore from "@/stores/userProfiles";
  import constants from "@/constants";
  const { NOT_FOUND_URL, NO_MORE_POSTS_OFFSET } = constants;
  import config from "@/config";
  import {
    getProfileByHandle,
    getProfileVideosByUserId,
    signUpUser,
  } from "@/api/index.js";

  const { siteDomain } = config;

  export let data;
  export let { handle, start } = data;

  $: item = $userProfileStore.list[handle];
  $: list = item && item.videos ? item.videos : [];
  $: lp = item ? item.lp : undefined;
  const breadcrumbJson = [
    { "@id": `${siteDomain}/`, name: "Home" },
    { "@id": `${siteDomain}/@${handle}`, name: "Profile" },
    {
      "@id": `${siteDomain}/@${handle}/feed`,
      name: "Profile feed",
    },
  ];
  let hasMoreProfileFeed = true;
  let fetchingProfileFeed = false;
  let hasStartParam = start > 0;
  let currentIndex = 0;

  $: hasUserData = !!(item && item.i);
  $: if (hasStartParam && list && list.length > 0) {
    hasStartParam = false;
    currentIndex = start < list.length ? start : 0;
  }

  /**
   *
   * @param reducerAction adds videos on swiping
   */
  const fetchProfileFeed = async (reducerAction = "concat") => {
    if (fetchingProfileFeed || lp === NO_MORE_POSTS_OFFSET) return;
    fetchingProfileFeed = true;

    try {
      const { d, lp: newLp } = await getProfileVideosByUserId(
        window.fetch,
        item.i,
        lp
      );
      if (newLp !== lp) {
        list = [...list, ...d];
        lp = newLp;
        userProfileStore.updateVideos(handle, d, newLp, reducerAction);
      }
      if (!d || d.length <= 0) {
        hasMoreProfileFeed = false;
      }
    } catch (e) {
      console.warn(e);
    } finally {
      fetchingProfileFeed = false;
    }
  };

  /**
   *
   * @param activeIndex calls method to add more videos if available on swipe
   */
  const onSwipe = async (activeIndex) => {
    currentIndex = activeIndex;
    if (list.length - currentIndex < 3 && hasMoreProfileFeed) {
      fetchProfileFeed("concat");
    }
  };

  onMount(async () => {
    if (!hasUserData) {
      try {
        item = await getProfileByHandle(window.fetch, handle);
      } catch (e) {
        console.warn(e);
      }
    }
    if (item && item.err) {
      await goto(NOT_FOUND_URL);
    }
    if (item) {
      userProfileStore.updateState(handle, item);
      if (list && list.length > 0) {
        userProfileStore.updateVideos(handle, list, lp, "replace");
      } else {
        await fetchProfileFeed("replace");
      }
    }
  });
  const toggleLikeCount = (action, index) => {
    userProfileStore.togglePostLike(action, handle, index);
  };
</script>

<main>
  <FeedWrapperHead {breadcrumbJson} />
  <FeedWrapper
    {onSwipe}
    {currentIndex}
    {list}
    showNavbar={false}
    {toggleLikeCount}
  />
</main>
